export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js